import outSide from "./outSide";
import XLSX from "xlsx";

export function checkCode(obj, res) {
    const code = res.data.code;
    if (code === 20000) {
        obj.$message.success(res.data.msg)
    } else {
        obj.$message.warning(res.data.msg)
    }
}

export function getDate() {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    return year + '-' + month + '-' +day + ' ' + hours + ':' + minutes + ':' + seconds;
}

// 判断设备是否为移动端的方法
export function isMobile() {
    return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent);
}

export function checkPhoneNumber(phoneNumber) {
    return /^(1[34578][0-9])\d{8}$/.test(phoneNumber);
}

export function checkCard(card) {
    return /^[1-9]\d{16}([0-9]|X|x)$/.test(card);
}

export function isNumber(number) {
    if (isNull(number)) return false;
    return /^\d+$/.test(number) && !/\./.test(number);
}

export function isDouble(data) {
    if (isNull(data)) return false;
    const list = String(data).split('\.');
    if (list.length > 2) return false;
    if (list.length === 1) return isNumber(list[0]);
    if (list.length === 2) return isNumber(list[0]) && isNumber(list[1]);
}

export function isNull(data) {
    return typeof data === 'undefined' || data === '' || data === ' ' || data === null || data.length === 0;
}

export function isCarNumber(data) {
    return !isNull(data) && /\d+/.test(data);
}

// 日期格式化
export function formatDate(date, sign) {
    let d = new Date(date);
    let m = d.getMonth() + 1;
    let dd = d.getDate();
    let sign1 = (sign == null || sign === 'undefined') ? '-' : sign;
    return '' + d.getFullYear() + sign1 + (m > 9 ? m : '0' + m) + sign1 + (dd > 9 ? dd : '0' + dd);
}

// 获取本周日期
export function getWeek() {
    var new_Date = new Date()
    var timesStamp = new_Date.getTime();
    var currenDay = new_Date.getDay();
    var dates = [];
    for(var i = 0; i < 7; i++) {
        var das = new Date(timesStamp + 24 * 60 * 60 * 1000 * (i - (currenDay + 6) % 7)).toLocaleDateString();
        dates.push(formatDate(das));
    }
    return dates;
}

// 获取最近一周日期
export function getNearWeek() {
    let data = [];
    const date = new Date();
    const temp = 1000 * 60 * 60 * 24;
    for (let i = 6; i >= 0; i--) {data.push(formatDate(new Date(date - temp * i)))};
    return data;
}

export async function checkPlaceSell(obj, data) {
    if (isNull(data)) {
        obj.$message.warning('请输入粮源地，格式为xx县xx镇xx乡xx村(屯)');
        return false;
    }
    const res = await outSide.getPlaceSellRule();
    let rule = res.data.data;
    let rules = rule.split('/');
    let num = 0;
    rules.forEach(e => {if (data.indexOf(e) !== -1) num++;});
    let ok = num >= 2;
    if (!ok) obj.$message.warning('请补全粮源地信息，格式为xx县xx镇xx乡xx村(屯)');
    return ok;
}

export function loadTable(data, name) {
    const workbook = XLSX.utils.book_new();
    data.forEach(e => {loadTableData(e.data, e.lab, e.title, workbook)});
    XLSX.writeFile(workbook, name + '.xlsx');
}

function loadTableData(data, lab, title, workbook) {
    let data1 = [];
    let tab = [];
    Object.keys(data[0]).forEach(e => {
        lab.forEach(j => {
            if (e === j.prop) tab.push(j.label);
        })
    })
    data1.push(tab);
    data.forEach(e => {data1.push(Object.values(e))});
    const sheet1 = XLSX.utils.aoa_to_sheet(data1);
    XLSX.utils.book_append_sheet(workbook, sheet1, title);
}

import sendMsg from './http';

export function test(data) {
    return sendMsg.post({
        url: '/test',
        data: data
    })
}

export function test2(data) {
    return sendMsg.post({
        url: '/test2',
        data: data
    })
}
